// extracted by mini-css-extract-plugin
export default {"loaderRow":"TableLoaderRow_loaderRow__d8KZr","loader":"TableLoaderRow_loader__uWUSN"};